const grey600Color = '#B2BABE';

export default grey600Color;
